/* AppLoader.js */
/* @author: anghello */

import React from 'react';
import LoadingOverlay from 'react-loading-overlay';
import { useAuth } from '../../Context/Auth/AuthContext';

export default function Loader() {
  const { loading, loadingMessage } = useAuth();

  return (
    <LoadingOverlay
      active={loading}
      spinner
      text={(loadingMessage) ? `${loadingMessage}...` : 'Loading...'}
      styles={{
        overlay: (base) => ({
          ...base,
          zIndex: 999999,
        })
      }}
    ></LoadingOverlay>
  );
}
